import { message } from "antd";
import React, { useEffect } from 'react';
import TrebbleConfigProvider from './ConfigProvider'; // Assuming this applies context
import useDefaultTrebbleAntDTokenConfig from '../helper/useDefaultTrebbleAntDTokenConfig';

// Get the theme config to apply it
const useMessageConfig = (useEditorTheme?: boolean) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });
  // Apply the theme config globally to the message component
  // Note: This might have side effects if message is used elsewhere without this context
  useEffect(() => {
    message.config({
      // Apply theme tokens if possible, e.g., duration, maxCount
      // Antd message doesn't directly accept token/algorithm for styling its content via config
      // Styling needs CSS overrides or a custom context approach.
      // top: themeConfig.token.marginXXL, // Example token usage if applicable
      maxCount: 3, // Example config
    });
  }, [themeConfig]); 
};

// Component to ensure config is applied within the React tree
const MessageConfigurator: React.FC<{ useEditorTheme?: boolean }> = ({ useEditorTheme }) => {
  useMessageConfig(useEditorTheme);
  return null; // This component doesn't render anything itself
};

// Wrapper object that mimics the antd message API
const TrebbleMessage = {
  // You might need to wrap each method if you want to pass useEditorTheme dynamically
  // For simplicity, we rely on the global config being set by MessageConfigurator
  success: (content: React.ReactNode, duration?: number, onClose?: () => void) => message.success(content, duration, onClose),
  error: (content: React.ReactNode, duration?: number, onClose?: () => void) => message.error(content, duration, onClose),
  info: (content: React.ReactNode, duration?: number, onClose?: () => void) => message.info(content, duration, onClose),
  warning: (content: React.ReactNode, duration?: number, onClose?: () => void) => message.warning(content, duration, onClose),
  loading: (content: React.ReactNode, duration?: number, onClose?: () => void) => message.loading(content, duration, onClose),
  open: message.open, // Directly expose complex methods or wrap them as needed
  destroy: message.destroy,
  useMessage: message.useMessage, // Expose the hook
  _configurator: MessageConfigurator, // Expose the configurator component
};

export default TrebbleMessage; 